import { UpdateClientApplicationApprovalForm } from "@components/Forms";

import { Card } from "@design-system/Card/Card";

type Props = {
  clientId: string;
  clientApplicationId: string;
};

export const ClientApplicationReviewCard = ({
  clientId,
  clientApplicationId,
}: Props) => {
  return (
    <Card>
      <Card.Header>
        <Card.Header.Title>Application review</Card.Header.Title>
      </Card.Header>
      <Card.Body>
        <UpdateClientApplicationApprovalForm
          clientId={clientId}
          clientApplicationId={clientApplicationId}
        />
      </Card.Body>
    </Card>
  );
};
